export default __webpack_public_path__ + "static/media/knight.df4ec67a.svg";